/** Interval at which to pull from the event-storage service. */
export const PULL_INTERVAL = 30_000;
/** Time after which to retry a failed pull or push. */
export const RETRY_FAILED_PUSH_OR_PULL_AFTER = 30_000;
